export const site = {
  name: "My Value Academy",
  shortName: "MVA",
  legalName: "My Value Trip - Academy",
  tagline: "Educate · Empower · Elevate",
  description:
    "Practical, career-focused education from experienced mentors. Build real-world skills with expert-led courses in technology, business, leadership and corporate training.",
  url: "https://academy.myvaluetrips.com",
  email: "admissions@myvalueacademy.com",
  phone: "+91 99795 12013",
  whatsapp: "+91 99795 12013",
  address: {
    line1: "My Value Academy, Shree Rani Sati Travel House, Behind Parag House, Udhana Darwaja, Aman Nagar",
    line2: "Surat, Gujarat 395002, India",
  },
  // Short query on purpose: the full address also matches the separate "MyValueTrip" listing and Google shows two pins.
  mapUrl: "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Shree Rani Sati Travel House, Udhana Darwaja, Surat 395002"),
  hours: "Mon – Sat · 9:30 AM – 6:30 PM IST",
  socials: {
    linkedin: "https://www.linkedin.com/company/my-value-academy",
    instagram: "https://www.instagram.com/myvalueacademy",
    facebook: "https://www.facebook.com/myvalueacademy",
    youtube: "https://www.youtube.com/@myvalueacademy",
    x: "https://x.com/myvalueacademy",
    whatsapp: "https://wa.me/919979512013",
  },
  founded: 2014,
} as const;

export interface NavItem {
  label: string;
  href: string;
}

export const primaryNav: NavItem[] = [
  { label: "About Us", href: "/about" },
  { label: "Courses", href: "/courses" }, // renders a dynamic course dropdown
  { label: "Corporate Training", href: "/corporate-training" },
  { label: "Blogs", href: "/blog" },
  { label: "Events", href: "/events" },
  { label: "Contact Us", href: "/contact" },
];

export const enquiryHref = "/contact?tab=enquiry#enquiry";

export const loginLinks: NavItem[] = [
  { label: "Student Login", href: "/login?role=student" },
  { label: "Employee Login", href: "/login?role=employee" },
];

export const footerNav = {
  company: [
    { label: "About Us", href: "/about" },
    { label: "Corporate Training", href: "/corporate-training" },
    { label: "Blogs", href: "/blog" },
    { label: "Events", href: "/events" },
    { label: "Contact Us", href: "/contact" },
  ],
  access: [
    { label: "Enquire Now", href: enquiryHref },
    ...loginLinks,
  ],
};
